import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import TabHeader from "@/components/admin/TabHeader";
import { field } from "@/pages/admin/AdminLogin";

export default function AccountTab({ forced = false }) {
  const { user, setUser } = useAuth();
  const [f, setF] = useState({ current_password: "", new_password: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (f.new_password.length < 8) return toast.error("New password needs at least 8 characters");
    if (f.new_password !== f.confirm) return toast.error("Passwords don’t match");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: f.current_password, new_password: f.new_password });
      toast.success("Password updated");
      setF({ current_password: "", new_password: "", confirm: "" });
      setUser({ ...user, must_change_password: false });
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };

  return (
    <div data-testid="admin-account-tab" className="max-w-md">
      <TabHeader title={forced ? "Choose your password" : "My account"} note={forced ? "Welcome. Before you start, replace the temporary password with one only you know." : user.email} />
      <form onSubmit={submit} className="space-y-4 bg-paper p-6">
        {[["current_password", forced ? "Temporary password" : "Current password"], ["new_password", "New password (8+ characters)"], ["confirm", "Confirm new password"]].map(([k, l]) => (
          <label key={k} className="block">
            <span className="overline mb-2 block text-[0.6rem] text-muted">{l}</span>
            <input data-testid={`account-${k}`} type="password" required value={f[k]} onChange={set(k)} className={field} />
          </label>
        ))}
        <button data-testid="account-save" disabled={busy} className="w-full bg-ink py-3 text-paper disabled:opacity-50"><span className="overline">{busy ? "Saving…" : "Update password"}</span></button>
      </form>
    </div>
  );
}
